import { showPopBanner } from '../../iba-components/PopBanner'
import { loginOpenAM, redirectIAM, logout } from '../api/commonV2'
import { wait } from '../utils'
import { ADMIN_HOME, V2_HOME } from '../constants'

const showError = (msg) =>
    showPopBanner({
        message: msg,
        status: 'error',
        duration: 5000
    })

const fetchLogoutUrl = async () => {
    const redirect_uri = window.location.origin + '/loginiam'
    try {
        const { logout_url } = await logout({ redirect_uri })
        return logout_url ? decodeURIComponent(logout_url) : redirect_uri
    } catch {
        return redirect_uri
    }
}

/**
 * PIAM認証リダイレクト
 */
export const auth = async (loginable) => {
    if (!loginable) return

    const { url } = await redirectIAM({
        login_type: 'SSO',
        redirecturi: window.location.origin + window.location.pathname
    })

    const downloadElement = document.createElement('a')
    downloadElement.setAttribute('href', url)
    downloadElement.click()
}

/**
 * ログイン処理
 */
export const doLogin = async (token, { updateUser, updateFilter, history, t, onLoadingChange, onLoginableChange }) => {
    onLoadingChange(true)

    let res
    try {
        res = await loginOpenAM({
            code: token,
            redirecturi: window.location.origin + window.location.pathname
        })
    } catch {
        onLoadingChange(false)
        onLoginableChange(false)
        showError(t('loginiam.networkErrorMsg', 'Login failed. Please try again.'))
        await wait(5000)
        window.location.href = await fetchLogoutUrl()
        return
    }

    const handleError = async (msg) => {
        onLoadingChange(false)
        onLoginableChange(false)
        showError(msg)
        await wait(5000)
        window.location.href = await fetchLogoutUrl()
    }

    // APIエラー
    if (res.hasError) {
        return handleError(res.desc)
    }

    // 緊急停止
    if (res.emrgncystop) {
        return handleError(t('loginiam.emergencyStopMsg'))
    }

    // アカウント停止
    if (res.terminated) {
        return handleError(t('loginiam.terminatedMsg'))
    }

    // アカウント削除
    if (res.deleted) {
        return handleError(t('loginiam.deletedMsg', t('loginiam.terminatedMsg')))
    }

    updateUser(res)
    onLoadingChange(false)

    updateFilter({
        countryName: 'ALL',
        countryid: 'ALL'
    })

    if (res.userinfo.is_admin) {
        history.replace(ADMIN_HOME)
        return
    }

    history.replace(V2_HOME)
}
